import { render, staticRenderFns } from "./campania-form.vue?vue&type=template&id=d3d2155c&scoped=true"
import script from "./campania-form.vue?vue&type=script&lang=js"
export * from "./campania-form.vue?vue&type=script&lang=js"
import style0 from "./campania-form.vue?vue&type=style&index=0&id=d3d2155c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d2155c",
  null
  
)

export default component.exports